<div class="modal-container custom-modal manage-modal-gts" id="wrapper">
    <div class="modal-header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap: 20px;">
            <h6 class="modal-title">{{ title }}</h6>            
        </div> 
        <div class="actions d-flex align-items-center justify-content-end" style="gap: 10px;">
            <span class="cursor close ml-0" style="top: 0px !important;" (click)="close()">
                <img src="assets/images/list-close.png" alt="Close" />
            </span>
        </div>       
    </div>
    <div class="modal-body">
        <div class="actions d-flex align-items-center justify-content-end" style="gap: 10px;">
            <div class="tabs">
                <button *ngFor="let type of assignTypes" class="tab {{type.class}}" [ngClass]="{'active': type.active}" (click)="switchTab(type)">{{type.name}}</button>
            </div>
        </div>
        <div *ngIf="!empty" id="manageTable" class="container scrollbar scrollbar-primary thin" [style.height.px]="height" style="max-width: 100% !important;width: 100% !important;">
            <!-- Internal User List -->
            <div *ngIf="activeAssignType == 1" class="rep-list">                
                <div class="rep-card" *ngFor="let user of internalListItems">
                    <img src="{{user.profile}}" alt="Profile" class="avatar">
                    <div class="rep-info">
                        <strong>{{user.name}}</strong>
                        <div class="role">Sales Rep</div>
                    </div>
                    <button class="assign-btn" (click)="assign(user.id)">Assign</button>
                </div>                
            </div>
            <!-- External User List -->
            <div *ngIf="activeAssignType == 2" class="user-list">
                <div *ngFor="let distributor of externalListItems" class="user-card">
                    <div class="icon">🏠</div>
                    <div class="info">
                        <strong>{{distributor.name}} (ID# {{distributor.id}})</strong><br>
                        <!--span>4901 Springdale Rd APT 105, Austin, TX, 78723-6165, aaronfolb@gmail.com, (818)802-9009</span-->
                        <span>{{distributor.type}}</span>
                    </div>
                    <button class="assign-btn" (click)="assign(distributor.id)">Assign</button>
                </div>
            </div>
        </div>
        <div *ngIf="empty" class="no-item-list" [style.height.px]="height">
            <div class="item-empty-container">
                <div class="empty-cont">
                    <div class="text-center empty-res">
                        <div class="empty-bg"></div>
                        <!-- <div>{{ successMsg }}</div> -->
                        <div>No result found</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>